import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { ReactComponent as DreamIcon } from '../../icons/dream-icon.svg';
import { ReactComponent as HomeIcon } from '../../icons/nav-links/home.svg';
import { ReactComponent as MemoryIcon } from '../../icons/nav-links/memory.svg';
import { ReactComponent as SettingsIcon } from '../../icons/nav-links/settings.svg';
import { ReactComponent as LogoutIcon } from '../../icons/nav-links/logout.svg';

export type UniTab = 'home' | 'activity' | 'reminders' | 'documents';

interface UniNavProps {
  activeTab: UniTab;
  onTabChange: (tab: UniTab) => void;
  activityCount?: number;
  remindersCount?: number;
  scrolled?: boolean;
}

const UniNav: React.FC<UniNavProps> = ({
  activeTab,
  onTabChange,
  activityCount,
  remindersCount,
  scrolled,
}) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div className={`uni-nav${scrolled ? ' scrolled' : ''}`}>
      <div className='uni-nav-left'>
        <Link to='/' className='uni-nav-logo' aria-label='Home'>
          <DreamIcon />
        </Link>
        <nav className='uni-nav-tabs'>
          <button
            type='button'
            className='uni-nav-tab home-tab'
            onClick={() => onTabChange('home')}
            aria-label='Home'
          >
            <HomeIcon />
          </button>
          <button
            type='button'
            className={`uni-nav-tab${activeTab === 'activity' ? ' active' : ''}`}
            onClick={() => onTabChange('activity')}
          >
            <span>Activity</span>
            {activityCount != null && activityCount > 0 && (
              <span className='uni-nav-tab-count'>{activityCount}</span>
            )}
          </button>
          <button
            type='button'
            className={`uni-nav-tab${activeTab === 'reminders' ? ' active' : ''}`}
            onClick={() => onTabChange('reminders')}
          >
            <span>Reminders</span>
            {remindersCount != null && remindersCount > 0 && (
              <span className='uni-nav-tab-count'>{remindersCount}</span>
            )}
          </button>
          <button
            type='button'
            className={`uni-nav-tab${activeTab === 'documents' ? ' active' : ''}`}
            onClick={() => onTabChange('documents')}
          >
            Documents
          </button>
        </nav>
      </div>
      <div className='uni-nav-right'>
        <Link to='/memory' className='uni-nav-icon-btn' aria-label='Memories'>
          <MemoryIcon />
        </Link>
        <Link to='/settings' className='uni-nav-icon-btn' aria-label='Settings'>
          <SettingsIcon />
        </Link>
        <button
          type='button'
          className='uni-nav-icon-btn'
          onClick={handleLogout}
          aria-label='Log out'
        >
          <LogoutIcon />
        </button>
      </div>
    </div>
  );
};

export default UniNav;
